import type { PrivateEvent } from '../../api/privateEvents';

import PrivateEventsTableRow from './PrivateEventsTableRow';

/**
 * The private-events list, desktop and tablet (BON-518). The phone layout is
 * `PrivateEventsCardList`; both share `privateEventDisplay` so the two cannot
 * drift, and that module documents why the location and deal-value strings read
 * the way they do.
 */
export default function PrivateEventsTable({
  events,
  onOpen,
}: {
  events: PrivateEvent[];
  onOpen?: (event: PrivateEvent) => void;
}) {
  return (
    <section className="nb-card nb-card-tight" style={{ padding: 0, overflowX: 'auto' }}>
      <table className="nb-tbl">
        <thead>
          <tr>
            <th>Date</th>
            <th>Client</th>
            <th>Location</th>
            <th>Headcount</th>
            <th>Staffing</th>
            <th>Deal value</th>
          </tr>
        </thead>
        <tbody>
          {events.map((event) => (
            <PrivateEventsTableRow key={event.id} event={event} onOpen={onOpen} />
          ))}
        </tbody>
      </table>
    </section>
  );
}
